const localRoutes = {
  homepage: '/',
  dashboard: '/dashboard',
  signup: '/signup',
  login: '/login',
  resetPassword: '/reset-password'
};

export default Object.freeze(localRoutes);
